import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Gender } from '../../models/gender.model';

@Component({
    selector: 'app-gender-selector',
    templateUrl: './gender-selector.component.html',
    styleUrls: ['./gender-selector.component.scss']
})
export class GenderSelectorComponent implements OnInit {

    @Input() genders         : Gender[];
    @Input() selected?       : Gender;
    @Input() defaultSelected?: boolean = false;
    @Input() placeholder?    : string = 'Seleccione un género...';
    @Input() showClear?      : boolean = false;

    @Output() selectedChange = new EventEmitter<Gender>();

    constructor() { }

    ngOnInit(): void {

        this.selected = this.defaultSelected ? this.genders[0] : this.selected;
        this.onSelectionChange();

    }

    public onSelectionChange() {

        this.selectedChange.emit(this.selected);

    }

}
